/* eslint-disable */
import { useEffect, useState } from 'react'
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import * as API from '../../../framework/API/api';
import { ENTITYNAME, TOAST_TYPES } from '../../../framework/constant/constant';
import ContentCategoryEditForm from '../../masters/ContentCategoryEditForm';
import { useTranslation } from '../../../locale/useTranslation';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import { utility } from '../../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../../components/EditPageHeader';
import ToastNotification from '../../../components/ToastNotification';

const ContentTreeViewForm = (props) => {

    const { height, handleSelectedCategory, isMultiSelect = false, isSaveButton = false, onClose, handleSelectedCategories } = props;

    const lang = useTranslation();

    const [treeData, setTreeData] = useState([]);
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [hashContentCategories, setHashContentCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [showContentCategoryModal, setShowContentCategoryModal] = useState({
        show: false,
        isEdit: false
    });

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        try {
            setSelectedCategory({});
            let contentCategoryRes = await API.getDataLookup(ENTITYNAME.ContentCategory, { query: ["Archive", "!=", true] });
            const categories = contentCategoryRes?.data ?? [];
            setHashContentCategories(categories);
            const tree = buildTreeStructure(categories);
            setTreeData(tree);
        } catch (error) {
            console.error('Error loading categories:', error);
        }
    };

    const buildTreeStructure = (categories) => {
        const categoryMap = new Map();
        const rootNodes = [];

        categories.forEach(cat => {
            categoryMap.set(cat._id, {
                ...cat,
                children: []
            });
        });

        categories.forEach(cat => {
            const node = categoryMap.get(cat._id);

            if (cat.parent) {
                const parentNode = categoryMap.get(cat.parent);
                if (parentNode) {
                    parentNode.children.push(node);
                } else {
                    rootNodes.push(node);
                }
            } else {
                rootNodes.push(node);
            }
        });

        const sortTree = (nodes) => {
            nodes.sort((a, b) => a.Name.localeCompare(b.Name));
            nodes.forEach(n => sortTree(n.children));
        };

        sortTree(rootNodes);

        return rootNodes;
    };

    const toggleNode = (nodeId) => {
        setExpandedNodes(prev => {
            const newSet = new Set(prev);
            if (newSet.has(nodeId)) {
                newSet.delete(nodeId);
            } else {
                newSet.add(nodeId);
            }
            return newSet;
        });
    };

    const getAllDescendantIds = (node) => {
        let ids = [node._id];
        if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
                ids = [...ids, ...getAllDescendantIds(child)];
            });
        }
        return ids;
    };

    const isNodeSelected = (nodeId) => {
        if (isMultiSelect) {
            return selectedCategories.some(cat => cat._id === nodeId);
        } else {
            return selectedCategory?._id === nodeId;
        }
    };

    const renderTreeNode = (node, level = 0) => {
        const hasChildren = node.children && node.children.length > 0;
        const isExpanded = expandedNodes.has(node._id);
        const isSelected = isNodeSelected(node._id);

        let nodeIcon = '•';
        let nodeLabel = node.Name;

        if (level === 0) {
            nodeIcon = hasChildren ? (isExpanded ? '▼' : '▶') : '•';
        } else if (level === 1) {
            nodeIcon = hasChildren ? (isExpanded ? '▼' : '▶') : '•';
        }

        const handleIconClick = (e) => {
            e.stopPropagation();
            if (hasChildren) {
                toggleNode(node._id);
            }
        };

        const handleLabelClick = async (e) => {
            e.stopPropagation();
            if (isMultiSelect) {
                const isAlreadySelected = selectedCategories.some(cat => cat._id === node._id);

                let updatedSelection;
                if (isAlreadySelected) {
                    // const descendantIds = getAllDescendantIds(node);
                    updatedSelection = selectedCategories.filter(
                        // cat => !descendantIds.includes(cat._id)
                        cat => !node._id.includes(cat._id)
                    );
                } else {
                    updatedSelection = [...selectedCategories, node];
                }
                setSelectedCategory(updatedSelection?.length > 0 ? updatedSelection[0] : {});
                setSelectedCategories(updatedSelection);
            } else {
                setSelectedCategory(node);
                handleSelectedCategory && handleSelectedCategory(node);
            }
        };

        return (
            <div key={node._id}>
                <div
                    className="tree-node"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 8px 8px ' + (level * 20 + 8) + 'px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                        transition: 'background-color 0.2s'
                    }}
                    onClick={handleLabelClick}
                    onMouseEnter={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    <span
                        style={{
                            marginRight: '8px',
                            fontWeight: hasChildren ? 'bold' : 'normal',
                            minWidth: '10px',
                            cursor: hasChildren ? 'pointer' : 'default'
                        }}
                        onClick={handleIconClick}
                    >
                        {nodeIcon}
                    </span>
                    <span
                        style={{
                            fontWeight: isSelected ? 'bold' : 'normal',
                            flex: 1,
                            cursor: 'pointer'
                        }}
                    >
                        {nodeLabel}
                    </span>
                </div>

                {hasChildren && isExpanded && (
                    <div className="tree-children">
                        {node.children.map(child => renderTreeNode(child, level + 1))}
                    </div>
                )}
            </div>
        );
    };

    const onDeleteContentCategory = async () => {
        let res = await API.onDeleteContentCategory({ id: selectedCategory?._id });
        if (res.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.ContentCategory);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            loadCombo();
            setSelectedCategory({});
            handleSelectedCategory && handleSelectedCategory({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onCancel = () => {
        setSelectedCategory({});
        setSelectedCategories([]);
        handleSelectedCategory && handleSelectedCategory({});
        onClose && onClose();
    }

    const handleSubmit = () => {
        let finalData = hashContentCategories.filter(cat => selectedCategories.some(selectedCat => selectedCat._id === cat._id));
        handleSelectedCategories && handleSelectedCategories(finalData);
        onCancel();
    }

    return (
        <>
            {isSaveButton && <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onCancel} saveButtonTitle={lang.select_button_text} />}
            <div className="tree-view-wrapper" style={{
                border: '1px solid #ddd',
                backgroundColor: '#fff',
                borderRadius: '4px',
                maxHeight: 'calc(100vh - 150px)',
                height: height ?? 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    margin: '0',
                    fontSize: '15px',
                    borderBottom: '2px solid #ddd',
                    padding: '10px 10px 10px 10px',
                    fontWeight: 'bold',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0
                }}>
                    <span>
                        <span style={{ marginRight: '5px', fontSize: '10px' }}>📋 </span>
                        {lang.content_categories_label}
                        {isMultiSelect && selectedCategories.length > 0 && (
                            <span style={{ marginLeft: '10px', fontSize: '12px', color: '#2196F3' }}>
                                ({selectedCategories.length} selected)
                            </span>
                        )}
                    </span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <RoundButton
                            icon="plus"
                            onClick={() => setShowContentCategoryModal({ show: true, isEdit: false })}
                            title={lang.add_content_category_label}
                        />
                        {(selectedCategory?._id || selectedCategories.length === 1) && <><RoundButton
                            icon="edit"
                            onClick={() => setShowContentCategoryModal({ show: true, isEdit: true })}
                            title={lang.edit_content_category_label}
                        />
                            <RoundButton
                                icon="trash"
                                onClick={() => ConfirmDeleteAlert(() => onDeleteContentCategory(), () => { })}
                                title={lang.delete_content_category_label}
                            /></>}
                    </div>
                </div>

                <div className="tree-view-container" style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: '10px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1'
                }}>
                    <style>
                        {`
                    .tree-view-container::-webkit-scrollbar {
                        width: 8px;
                    }
                    .tree-view-container::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb {
                        background: #888;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb:hover {
                        background: #555;
                    }
                `}
                    </style>
                    {treeData.length > 0 ? (
                        treeData.map(node => renderTreeNode(node))
                    ) : (
                        <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                            {lang.no_categories_found_message}
                        </p>
                    )}
                </div>
            </div>
            {showContentCategoryModal.show && <ContentCategoryEditForm item={showContentCategoryModal.isEdit ? selectedCategory : { parent: selectedCategory?._id }} cancelEdit={() => setShowContentCategoryModal(false)} refresh={loadCombo} />}
        </>
    )
}

export default ContentTreeViewForm;
